var map = {
	"./tutorial-normal-attraction-2.jpg": "Ut5Q",
	"./tutorial-tool-attraction-2.jpg": "qPRf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xPuW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/tutorial\-.*\-attraction\-2\.jpg$
// module id = xPuW
// module chunks = 3